<!-- Page Content -->
<div class="content">
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">

                <!-- Login Content -->
                <div class="account-content">
                    <div class="align-items-center justify-content-center">
                        <div class="login-right">
                            <div class="login-header text-center">
                                <a [routerLink] = "'/home'"><img src="assets/img/logo-01.png" alt="logo" class="img-fluid"></a>
                                <h3>Bienvenido</h3>
                                <p>No pierdas tu próxima oportunidad. Registrate para comenzar a operar.</p>
                              <div class="error-container">
                                <div *ngIf="loginError">Error en usuario y/o contraseña</div>
                              </div>
                            </div>
                          <Form [formGroup]="loginForm" (ngSubmit)="enviar(loginForm.value)" autocomplete="off">
                            <div class="form-group form-focus">
                              <input formControlName="email" type="text" class="form-control floating">
                              <label class="focus-label"  [ngClass]="{'filled': loginForm.controls.email.value}">Email o Usuario </label>
                            </div>
                            <div class="form-group form-focus">
                              <hugeicons-icon class="custom-icon" [icon]="showPassword ? ViewIcon : ViewOffSlashIcon" (click)="togglePasswordVisibility()" [size]="20" [strokeWidth]="2"></hugeicons-icon>
                              <!-- <i class="custom-icon fas" [ngClass]="{ 'fa-eye': !showPassword, 'fa-eye-slash': showPassword }" (click)="togglePasswordVisibility()"></i> -->
                              <input formControlName="password" type="{{ showPassword ? 'text' : 'password' }}" class="form-control floating">
                              <label class="focus-label"  [ngClass]="{'filled': loginForm.controls.password.value}">Contraseña</label>
                            </div>
                            <div class="form-group">
                              <label class="custom_check">
                                <input type="checkbox" formControlName="remember">
                                <span class="checkmark"></span> Recordar contraseña
                              </label>
                            </div>
                            <button class="btn btn-primary btn-block btn-lg login-btn" type="submit">Ingresar</button>
                            <div class="row">
                              <div class="col-5 text-start">
                                <a class="forgot-link" [routerLink] = "'/forgot-password'">¿Olvidaste la contraseña?</a>
                              </div>
                              <div class="col-7 text-end dont-have">¿Eres nuevo en Mercado Cheque? Haz <a class="text-nowrap" [routerLink] = "'/register'">Click aquí</a></div>
                            </div>
                            <div class="row">
                              <div class="col-12 text-center small-text pt-5">
                                Versión: {{appVersion}}
                              </div>
                            </div>
                          </Form>

<!--                                <div class="login-or">-->
<!--                                    <p>Or login with</p>-->
<!--                                </div>-->
<!--                                <div class="row social-login">-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-twitter btn-block"> Twitter</a>-->
<!--                                    </div>-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-facebook btn-block"> Facebook</a>-->
<!--                                    </div>-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-google btn-block"> Google</a>-->
<!--                                    </div>-->
<!--                                </div>-->
                        </div>
                    </div>
                </div>
                <!-- /Login Content -->

            </div>
        </div>
    </div>
</div>
<!-- /Page Content -->
